const amount = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

const sumTraceRows = (rows = []) => (
  (Array.isArray(rows) ? rows : []).reduce((total, row) => total + amount(row?.amount), 0)
);

// These are display-only payment totals. Authoritative salary balances, carry,
// and payable figures remain the values supplied by the payroll API.
export const buildSalaryCycleDisplay = (summary = {}) => {
  const previous = summary.previousCycleTrace || {};
  const previousSalaryPaid = sumTraceRows(previous.salaryPayments);
  const previousAdvance = sumTraceRows(previous.advances);
  const previousBonus = sumTraceRows(previous.bonuses);
  const previousGift = sumTraceRows(previous.gifts);
  const currentSalaryPaid = amount(
    summary.currentCycleSalaryPayments ?? summary.totalSalaryPaidInCycle
  );
  const currentAdvance = amount(summary.totalAdvance);
  const currentBonus = amount(summary.totalBonus);
  const currentGift = amount(summary.totalGift);

  return {
    previous: {
      earned: amount(previous.cycleEarned),
      deductions: sumTraceRows(previous.deductions),
      salaryPaid: previousSalaryPaid,
      advances: previousAdvance,
      bonus: previousBonus,
      gift: previousGift,
      nonSalaryReceived: previousBonus + previousGift,
      totalReceived: previousSalaryPaid + previousAdvance + previousBonus + previousGift,
    },
    current: {
      salaryPaid: currentSalaryPaid,
      advances: currentAdvance,
      deductions: amount(summary.totalDeductions),
      bonus: currentBonus,
      gift: currentGift,
      nonSalaryReceived: currentBonus + currentGift,
      totalReceived: currentSalaryPaid + currentAdvance + currentBonus + currentGift,
    },
  };
};
